import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { tokens } from '../../../../design/tokens';

export const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px;
  background: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.md};

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Title = styled.h2`
  margin: 0 0 20px 0;
  color: ${tokens.color.textWhite};
  font-size: 1.4rem;
  font-weight: 600;
`;

export const CourseBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 20px;
  background: ${tokens.color.stageBlack};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.md};
  flex-wrap: wrap;
`;

export const CourseLabel = styled.label`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.label.size};
  font-weight: ${tokens.font.label.weight};
  white-space: nowrap;
`;

export const CourseSelect = styled.select`
  flex: 1;
  min-width: 220px;
  height: 42px;
  padding: 0 12px;
  border-radius: ${tokens.radius.sm};
  border: 1px solid ${tokens.color.railGraphite};
  background: ${tokens.color.fieldSlate};
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.6;
  }

  option {
    color: #000;
    background: #fff;
  }
`;
export const TabContainer = styled.nav`
  display: flex;
  gap: 4px;
  margin-bottom: 24px;
  border-bottom: 1px solid ${tokens.color.railGraphite};
  overflow-x: auto;

  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
`;

export const TabLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: ${tokens.color.textAsh};
  text-decoration: none;
  font-size: ${tokens.font.body.size};
  font-weight: 500;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  transition: color 0.2s, border-color 0.2s;

  &:hover {
    color: ${tokens.color.textWhite};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: -2px;
  }

  &.active {
    color: ${tokens.color.marqueeGold};
    border-bottom-color: ${tokens.color.marqueeGold};
  }
`;

export const Content = styled.div`
  width: 100%;
`;
